// Migration helper for opener settings. v1 is a no-op; the structure exists
// so that future preset version bumps have an obvious place to add migration
// steps without touching call sites.

/**
 * @param {string} presetId
 * @param {number} fromVersion
 * @param {Object} settings
 * @returns {Object} settings in the current preset version
 */
export function migrateOpenerSettings(presetId, fromVersion, settings) {
  if (!settings || typeof settings !== 'object') return {};
  // v1: identity. Add `if (presetId === 'rain-on-cotton-paper' && fromVersion < 2) { ... }` here later.
  return settings;
}
